module.exports = __webpack_public_path__ + "img/ic_halfstar_on.a4d4462a.svg";